const NAN_VALUE = "-";

const DEFAULT_CURRENCY_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
});

const PERCENT = new Intl.NumberFormat("en-US", {
  style: "percent",
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export namespace NumberUtils {
  export const CPI_INFLATION_RATE = 0.02;

  export const formatAsUSCurrency = (
    value: number,
    options?: {
      maximumDecimalPlaces?: number;
      maximumSignificantDigits?: number;
      useAbsoluteValue?: boolean;
      showDollarSign?: boolean;
    },
  ): string => {
    if (Number.isNaN(value)) return NAN_VALUE;

    if (!options) {
      return DEFAULT_CURRENCY_FORMATTER.format(value);
    }

    const valueToFormat = options?.useAbsoluteValue ? Math.abs(value) : value;
    const showDollarSign = options?.showDollarSign ?? true;

    if (showDollarSign) {
      const valueFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: options?.maximumDecimalPlaces ?? 0,
        maximumSignificantDigits: options?.maximumSignificantDigits,
      });
      return valueFormatter.format(valueToFormat);
    }
    const valueFormatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: options?.maximumDecimalPlaces ?? 0,
      maximumSignificantDigits: options?.maximumSignificantDigits,
    });
    return valueFormatter.format(valueToFormat);
  };

  export const formatNumberToShort = (value: number, useAbsoluteValue = false) => {
    const absValue = useAbsoluteValue ? Math.abs(value) : value;
    if (absValue >= 1000000) {
      return `$${(absValue / 1000000).toFixed(1)}M`;
    }
    if (absValue >= 1000) {
      return `$${(absValue / 1000).toFixed(0)}K`;
    }
    return `$${absValue}`;
  };

  export const formatPercent = (value: number): string => {
    if (Number.isNaN(value)) return NAN_VALUE;
    return PERCENT.format(value);
  };
}
